import React from 'react';
import Modal, { ModalProps } from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';

interface IProps extends ModalProps {
    
}

type ItemType = {
    label: string;
    value: string | number | undefined;
}

const AboutModal: React.FunctionComponent<IProps> = (props: IProps) => {
    const items: Array<ItemType> = [
        {label: "Version Number", value: process.env.REACT_APP_VERSION},
        {label: "API URL", value: process.env.REACT_APP_API_URL},
        {label: "Client Id", value: process.env.REACT_APP_CLIENT_ID},
        {label: "Redirect URI", value: process.env.REACT_APP_REDIRECT_URI},
        {label: "Logging URL", value: process.env.REACT_APP_LOGGING_API_URL},
        {label: "Auxiliary URL", value: process.env.REACT_APP_AREA51_BASEURL},
        {label: "Picture URL", value: process.env.REACT_APP_IMG_API_URL}
    ];
    return (
        <Modal {...props} size="lg" className="z-100">
            <Modal.Header className="d-flex flex-row justify-content-center align-items-center">
                <Modal.Title>About</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table>
                    <tbody>
                        {items.map((item: ItemType, index: number) => (
                            <tr key={index}>
                                <td className="font-weight-bold">{item.label}</td>
                                <td>{item.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    );
}

export default AboutModal;